/**
 * Fundo Detalhe — Page script
 * Importa apenas os módulos necessários para a página de detalhe de fundo
 */

import { initStickyNav }      from '../modules/Components/sticky-nav.js';
import { initFundChart }      from '../modules/Components/fund-chart.js';
import { initDailyRate }      from '../modules/Components/daily-rate.js';
import { initColumnsSlider }  from '../modules/Components/columns-slider.js';
import { initCarteiraFundo }  from '../modules/Components/carteira-fundo.js';
import { initVideoPlayer }    from '../modules/Components/video-player.js';

function init() {
	initStickyNav();
	initFundChart();
	initDailyRate();
	initColumnsSlider();
	initCarteiraFundo();
	initVideoPlayer();
	initSecaoParam();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}

// ── Scroll automático via ?secao=documentos (ex: vindo de /ofertas) ──
function initSecaoParam() {
	if (new URLSearchParams(window.location.search).get('secao') !== 'documentos') return;

	const target = document.getElementById('secao-documentos');
	if (!target) return;

	requestAnimationFrame(() => {
		const nav = document.querySelector('[data-sticky-nav] .sticky-nav');
		const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
		const offset = nav ? nav.offsetHeight + 20 : 11.1 * rootFontSize;
		const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);

		window.scrollTo({ top, behavior: 'smooth' });
	});
}
